import React from 'react';
import PropTypes from 'prop-types';
import ModalInfo from 'shared/components/modal-info/ModalInfo';
import './WhatsNewModal.scss';

export function WhatsNewModal({ isOpen, features, onDismiss }) {
  return (
    <ModalInfo
      modalIsOpen={isOpen}
      closeModal={onDismiss}
      headerTitle="What's New in TCM"
      showBottomButton={true}
      bottomButtonLabel="Got it"
    >
      {features.map(f => (
        <div key={f.name} className="whats-new-feature-card">
          <h5>{f.title}</h5>
          {f.description.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      ))}
    </ModalInfo>
  );
}

WhatsNewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.arrayOf(PropTypes.string).isRequired,
  })).isRequired,
  onDismiss: PropTypes.func.isRequired,
};
